import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");

  const toggle = useCallback(() => {
    setLang((prev) => (prev === "it" ? "en" : "it"));
  }, []);

  // t("nav.about") -> deep lookup with fallback to italian then key
  const t = useCallback(
    (path) => {
      const read = (obj) =>
        path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
      const val = read(translations[lang]);
      if (val != null) return val;
      const fallback = read(translations.it);
      return fallback != null ? fallback : path;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
